export const CURRENT_POOL_STORAGE_KEY = 'langtan.currentPoolId';

/** 泳池 ID（雪花 Long），必须用字符串，禁止 Number() 以免丢精度 */
export type PoolId = string;

export function normalizePoolId(
  id: string | number | null | undefined,
): PoolId | undefined {
  if (id == null || id === '') {
    return undefined;
  }
  const s = String(id).trim();
  if (!s || s === 'NaN' || s === 'undefined') {
    return undefined;
  }
  return s;
}

export function poolIdEquals(
  a: string | number | null | undefined,
  b: string | number | null | undefined,
): boolean {
  const left = normalizePoolId(a);
  const right = normalizePoolId(b);
  return left != null && right != null && left === right;
}

export function getCurrentPoolId(): PoolId | undefined {
  try {
    return normalizePoolId(localStorage.getItem(CURRENT_POOL_STORAGE_KEY));
  } catch {
    return undefined;
  }
}

export function setCurrentPoolId(id: string | number) {
  const normalized = normalizePoolId(id);
  if (normalized == null) {
    return;
  }
  try {
    localStorage.setItem(CURRENT_POOL_STORAGE_KEY, normalized);
  } catch {
    // ignore storage failures
  }
}
